import { columnSummaryMapper } from 'common/utils/utils';
import { INCIDENTS_MODEL, INCIDENTS_TABLE_MODEL } from '../incidents.model';

const useCols = ({ incidents }) => {
  const cols = [
    {
      dataPoint: INCIDENTS_TABLE_MODEL.INCIDENT_CELL,
      name: 'INCIDENTS',
      summary: INCIDENTS_MODEL.SUMMARY.INCIDENTS
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.STATUS_CELL,
      name: 'STATUS',
      isSortedCol: true,
      sortPoint: INCIDENTS_MODEL.STATUS
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.SOURCE_CELL,
      name: 'SOURCE',
      isSortedCol: true,
      sortPoint: INCIDENTS_MODEL.SOURCE
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.ISSUED_AT_CELL,
      name: 'ISSUED AT',
      isSortedCol: true,
      sortPoint: INCIDENTS_MODEL.ISSUED_AT
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.STARTED_AT_CELL,
      name: 'STARTED AT',
      isSortedCol: true,
      sortPoint: INCIDENTS_MODEL.STARTED_AT
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.ENDED_AT_CELL,
      name: 'ENDED AT',
      isSortedCol: true,
      sortPoint: INCIDENTS_MODEL.ENDED_AT
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.REPOSITORIES_CELL,
      name: 'REPOSITORIES'
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.SERVICES_CELL,
      name: 'SERVICES'
    },
    {
      dataPoint: INCIDENTS_TABLE_MODEL.TEAMS_CELL,
      name: 'TEAMS'
    }
  ];
  const colsWithSummary = cols.map(col => columnSummaryMapper(col, incidents));
  return colsWithSummary;
};

export default useCols;
